import {
    useVideoPlayer,
    useVideoPlayerState,
} from '@components/@shared/VideoPlayer';
import {Slider} from '@mui/material';
import React, {useRef} from 'react';
import styles from './VideoPlayerProgressSlider.module.css';

const VideoPlayerProgressSlider: React.FC = () => {
    const {seek, _onScrubStart, _onScrubEnd} = useVideoPlayer();
    const currentTime = useVideoPlayerState(s => s.currentTime);
    const videoDuration = useVideoPlayerState(s => s.duration);

    const isScrubbingRef = useRef(false);

    const handleSliderChange = (_: Event, newValue: number | number[]) => {
        const value = Array.isArray(newValue) ? newValue[0] : newValue;

        if (!isScrubbingRef.current) {
            isScrubbingRef.current = true;
            _onScrubStart();
        }

        seek(value);
    };

    const handleSliderChangeCommitted = () => {
        if (!isScrubbingRef.current) {
            return;
        }
        isScrubbingRef.current = false;
        _onScrubEnd();
    };

    return (
        <div className={styles.container} onClick={e => e.stopPropagation()}>
            <Slider
                size="small"
                value={currentTime}
                min={0}
                max={videoDuration || 100}
                onChange={handleSliderChange}
                onChangeCommitted={handleSliderChangeCommitted}
                className={styles.slider}
                aria-label="Video progress"
                valueLabelDisplay="auto"
                valueLabelFormat={value =>
                    `${Math.floor(value / 60)}:${String(Math.floor(value % 60)).padStart(2, '0')}`
                }
            />
        </div>
    );
};

export default VideoPlayerProgressSlider;
